import { RouteObject } from 'react-router-dom';
import publicRoutes from './public';
import protectedRoutes from './protected';

export const routes: RouteObject[] = [...publicRoutes, ...protectedRoutes];

export default routes;
